import {
  RegistryRestClient,
  registryPaymentHandlerInjectionToken,
  registryApiUrlInjectionToken,
  registryRestClientInjectionToken
} from "@zaeper/angular-registry-lib";
import { RegistryStripePaymentHandler } from "./services/registry/registry-stripe-payment-handler.service";
import { HostUtil } from "./utils/host-util";
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, RouteReuseStrategy, withInMemoryScrolling, withRouterConfig } from '@angular/router';

import { provideLottieOptions } from "ngx-lottie";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { authInterceptor } from "./interceptors/auth.interceptor";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { providePrimeNG } from "primeng/config";
import { BloxPreset } from "@zaeper/primeng-themes";
import { DictionaryService, ILanguageStateService } from "@zaeper/localization-lib";
import { routes } from "./routing/app.routes";
import { provideAnimations } from "@angular/platform-browser/animations";
import { GuardsModule } from "./routing/guards/guards.module";
import { AppRouteReuseStrategy } from "./routing/app-route-reuse-strategy";
import { languageResolverServiceInjectionToken } from "./services/language/languageResolverServiceInjectionToken";
import { LanguageResolverService } from "./services/language/languageResolver.service";
import { dictionaryServiceInjectionToken } from "@zaeper/angular-localization-lib";
import { languageStateServiceInjectionToken } from "./services/language/languageStateServiceInjectionToken";
import {
  dictionaryResolverServiceInjectionToken
} from "./services/dictionary/dictionary-resolver-service-injection-token";
import { DictionaryResolverService } from "./services/dictionary/dictionaryResolver.service";
import { RestClientsModule } from "./rest-clients/rest-clients.module";
import { ServicesModule } from './services/services.module';
import { GlobalStatesModule } from "./global-states/global-states.module";
import { ResolversModule } from "./routing/resolvers/resolvers.module";
import {
  BlockingLoaderService,
  blockingLoaderServiceInjectionToken,
  BlockingLoaderStateService,
  blockingLoaderStateServiceInjectionToken,
  ModalModule,
  ThemeModule,
  ToastModule,
  ToastService,
  toastServiceInjectionToken,
  ToastStateService,
  toastStateServiceInjectionToken
} from "@zaeper/angular-dashboard-view-lib";
import { ConfirmationService } from "primeng/api";
import { xsrfInterceptor } from '@zaeper/angular-core-lib';

const dictionaryServiceFactory = (languageStateService: ILanguageStateService) => {
  return new DictionaryService( languageStateService );
};

export function playerFactory() {
  return import("lottie-web");
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideLottieOptions( {
      player: () => import("lottie-web")
    } ),
    provideHttpClient( withInterceptors([xsrfInterceptor, authInterceptor]) ),
    provideAnimationsAsync(),
    provideAnimations(),
    provideZoneChangeDetection( { eventCoalescing: true } ),
    provideRouter( routes, withInMemoryScrolling( {
      scrollPositionRestoration: "enabled"
    } ), withRouterConfig( {
      onSameUrlNavigation: "reload"
    } ) ),
    provideLottieOptions( {
      player: playerFactory
    } ),
    providePrimeNG( {
      theme: {
        preset: BloxPreset,
        options: {
          cssLayer: {
            name: "primeng",
            order: "base, primeng, primeicons, app-theme, components, theme, utilities"
          },
          darkModeSelector: ".app-dark"
        }
      }
    } ),
    importProvidersFrom( GuardsModule, RestClientsModule, ServicesModule, GlobalStatesModule, GuardsModule, ResolversModule, ToastModule.forRoot(), ModalModule, ThemeModule ),
    ConfirmationService,
    {
      provide: RouteReuseStrategy,
      useClass: AppRouteReuseStrategy
    },
    {
      provide: languageResolverServiceInjectionToken,
      useClass: LanguageResolverService
    },
    {
      provide: dictionaryServiceInjectionToken,
      useFactory: dictionaryServiceFactory,
      deps: [ languageStateServiceInjectionToken ]
    },
    {
      provide: dictionaryResolverServiceInjectionToken,
      useClass: DictionaryResolverService
    },
    { provide: toastServiceInjectionToken, useClass: ToastService },
    { provide: toastStateServiceInjectionToken, useClass: ToastStateService },
    { provide: blockingLoaderStateServiceInjectionToken, useClass: BlockingLoaderStateService },
    { provide: blockingLoaderServiceInjectionToken, useClass: BlockingLoaderService },
    { provide: registryApiUrlInjectionToken, useFactory: () => HostUtil.getRegistryApiEndpointUrl() },
    { provide: registryRestClientInjectionToken, useClass: RegistryRestClient },
    { provide: registryPaymentHandlerInjectionToken, useClass: RegistryStripePaymentHandler },
  ]
};
